import React, {useState, useContext, useRef, useEffect} from 'react'
import{ useForm } from 'react-hook-form'
import { collection, setDoc, doc, addDoc, getDocs, where, query, serverTimestamp} from "firebase/firestore";
import { db } from "../firebase-config";
import {v4 as uuidv4} from 'uuid'
import Edition from './Edition.js'
import { FaSearch } from "react-icons/fa";

export default function Form() {

    const [datas, setDatas] = useState([])
  
    const [defaultValues, setDefaultValues] = useState({})

    const loadDatas = async () => {
        setDatas([])
        const ref = collection(db, 'spro')
        const querySnapshot = await getDocs(ref)
        querySnapshot.forEach((doc) => {
            setDatas(datas => [doc.data(), ...datas])
        })

    }

    const checkForm = useRef()
    console.log(defaultValues);
    

    useEffect(() => {
        loadDatas()
    }, [])

    console.log(datas);

    const { register, handleSubmit, setError, reset, formState: {errors, isSubmitting, isSubmitted, isSubmitSuccessful }  } = useForm({
        mode: 'onChange',
    })

    const { register: register2, handleSubmit: handleSumbit2, setError: setError2, reset: reset2, formState: {errors: errors2, isSubmitting: isSubmitting2, isSubmitted: isSubmitted2, isSubmitSuccessful: isSubmitSuccessful2 }  } = useForm({
        mode: 'onChange',
    })

    const onSubmit = async (data) => {
        setDefaultValues({})
        if(datas.filter(dataSub => dataSub.EMAIL === data.email)) {     
           const filter = datas.filter(dataSub => dataSub.EMAIL === data.email)
           setDefaultValues(filter[0])
        } else {
            setDefaultValues({})
            alert("Vous n'êtes pas encore inscrit")
        }
        checkForm.current.reset("")
        
    }

    console.log(defaultValues);

    return (
    <div>
      <div className="box">
        <form ref={checkForm} className="subCheck" onSubmit={handleSubmit(onSubmit)}>
            <input {...register('email')} placeholder="Entrez votre adresse email" name="email" type="email"/>
            <button><FaSearch /></button>
        </form>
      </div>



       <Edition defaultValues={defaultValues} />   
 
    </div>
  )
}
